import { useFormik } from "formik";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo1 from "../../assets/images/logo/logo-white.png";
import "../../index.css";
import success from '../../assets/images/success.svg'

const PasswordResetSuccessfull = () => {
    return (
        <div className="container-fluid loginpage">
            <div className="col-sd-3 col-md-6 col-lg-4  container card card-success d-flex justify-content-center">
                <div style={{ textAlign: 'center', display: 'flex', justifyContent: "center", alignItems: 'center', textAlign: 'center' }}>
                    <Link to={'/'} style={{ width: '50%' }}>
                        <img src={logo1} className=" " alt="..." />
                    </Link>
                </div>
                <Link to={'/'}><h5 className="card-title">AL Asab</h5></Link>
                <div className="passwordSuccess">
                    <img src={success} alt="success" />
                    <h2>Password Reset<br /> Successfully</h2>
                </div>

                <Link className="loginAnchor" to={'/'} >
                    <button className="success-button" type="submit">
                        Login
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default PasswordResetSuccessfull;
